<template>
    <div class="wechat-key-wrap">
        <div class="header-return">
            <el-row :gutter="20">
                <el-col :span="2">
                    <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                </el-col>
                <el-col :span="2" offset="18">
                    <el-tooltip class="item" effect="dark" content="点击查询" placement="right">
                        <el-button type="primary" size="mini" @click="getList">查询</el-button>
                    </el-tooltip>
                </el-col>
                <el-col :span="2">
                    <el-tooltip class="item" effect="dark" content="新增多套文案" placement="right">
                        <el-button type="success" size="mini" @click="handleAdd">新增</el-button>
                    </el-tooltip>
                </el-col>
            </el-row>
        </div>
        <el-table :data="listData" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
            <el-table-column type="index" label="序号" width="60"></el-table-column>

            <el-table-column prop="keyword" label="关键字"></el-table-column>
            <el-table-column prop="title" :formatter="titleProccess" label="标题"></el-table-column>
            <el-table-column prop="content" label="内容" >
                <template slot-scope="scope">
                    {{scope.row.content=null?"":scope.row.content}}
                </template>
            </el-table-column>
            <el-table-column prop="type" :formatter="keywordType" label="类型" sortable width="80">
            </el-table-column>
            <el-table-column prop="createTime" label="创建日期" sortable width="180"></el-table-column>
            <el-table-column prop="execTypeName" label="执行类型" width="180"></el-table-column>
            <el-table-column prop="execTypeValue" label="类型值" width="180"></el-table-column>
            <el-table-column prop="sort" label="排序"></el-table-column>
            <el-table-column label="操作" fixed="right" width="180">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button type="primary" size="mini" @click="handleEdit(scope.row)">修改</el-button>
                        <el-button type="danger" size="mini" @click="handleDel(scope.row)">删除</el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog title="新增/修改" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="80px">
                <el-form-item label="id" :hidden="true">
                    <el-input v-model=form.keyworldId></el-input>
                </el-form-item>
                <el-form-item label="id" :hidden="true">
                    <el-input v-model=form.worldContentId></el-input>
                </el-form-item>
                <el-form-item label="关键字">
                    <el-input v-model=form.keyword disabled="true"  clearable placeholder="关键字"></el-input>
                </el-form-item>
                <el-form-item label="类型">
                    <el-select v-model="form.type" disabled="true" filterable clearable placeholder="类型" @change="keywordTypeChange">
                        <el-option v-for="item in keywordTypeData"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <template v-if="type=='text'||type=='card'">
                    <el-form-item label="标题">
                        <el-input type="textarea"
                                  :rows="5" v-model=form.title clearable placeholder="长度不要超过1000个字符"></el-input>
                    </el-form-item>
                    <el-form-item label="摘要">
                        <el-input type="textarea"
                                  :rows="5" v-model=form.content clearable placeholder="长度不要超过1000个字符"></el-input>
                    </el-form-item>
                    <el-form-item label="URL">
                        <el-input v-model="form.url" clearable placeholder=" h5跳转连接  如类型是卡片请填写小程序路径 "></el-input>
                    </el-form-item>
                </template>

                <el-form-item label="素材" v-if="type=='news'">
                    <el-select v-model="form.mediaId" style="width:100%" filterable clearable placeholder="素材">
                        <el-option v-for="item in mediaData"
                                   :key="item.mediaId"
                                   :label="item.title"
                                   :value="item.mediaId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="卡片" v-if="type=='card'">
                    <el-select v-model="form.mediaId" style="width:100%"
                               filterable
                               remote
                               clearable
                               reserve-keyword
                               :remote-method="getCardList"
                               :loading="loading"
                               placeholder="选择小程序卡片">
                        <el-option v-for="item in cardData"
                                   :key="item.mediaId"
                                   :label="item.title"
                                   :value="item.mediaId">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="图片" v-if="type=='image'">
                    <el-button @click="selectUpload" size="mini">上传图片</el-button>
                    <el-image
                            class="select-pic"
                            style="width: 100px; max-height: 200px;display:block;margin-top: 10px"
                            :src="form.imageUrl"
                            :preview-src-list="[form.imageUrl]">
                    </el-image>
                </el-form-item>
                <el-form-item label="执行时间" v-show="form.execType==1">
                    <el-select v-model="form.execTypeValue" placeholder="执行时间">
                        <el-option v-for="item in execTypeValueList"
                                   :key="item.name"
                                   :label="item.name"
                                   :value="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="排序">
                    <el-input-number v-model="form.sort" :min="1" :max="100" label="位数"
                                     placeholder="数字越小越靠前"></el-input-number>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="mini" @click="save(form)">确 定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {
        getKeywordContentList,
        deleteKeywordMessageContent,
        saveKeywordMessageContent,
        getKeywordMessageContent,
        getKeyword,
        getWeekList,
        getPlatformList
    } from '../../api/api';
    import uploadComponents from '@/components/upload';
    //定义组件
    export default{
        data(){
            return {
                listData: [],
                platformData: [],
                keywordTypeData: [{"id": "text", "name": "文本"}, {"id": "news", "name": "图文"}, {
                    "id": "image",
                    "name": "图片"
                }, {"id": "coupon", "name": "优惠券"}, {"id": "miniCard", "name": "小程序卡片"}],
                mediaData: [],
                cardData: [],
                loading: true,
                dialogFormVisible: false,
                execTypeValueList: [],

                form: {
                    "keyworldId": '' || this.$route.query.keyworldId,
                    "keyword": "",
                    "type": "text",
                    "title": "",
                    "content": "",
                    "mediaId": "",
                    "url": "",
                    "imageUrl": ""
                },
                textVisible: false,
                newsVisible: true,
                imageVisible: true,
                cardVisible: true,
                formInline: {
                    "keyworldId": 0 || this.$route.query.keyworldId,
                },
                platformDisabled: false,
            }
        },
        //挂载时候执行
        mounted(){
            this.getList();
            this.getWeekDataList();
        },
        components: {
            uploadComponents
        },

        methods: {
            //定义查询方法
            keywordTypeChange(data){
                console.log(data);
                if (data == "text") {
                    this.textVisible = false;
                    this.newsVisible = true;
                    this.imageVisible = true;
                    this.cardVisible = true;
                }
                if (data == "image") {
                    this.textVisible = true;
                    this.newsVisible = true;
                    this.imageVisible = false;
                    this.cardVisible = true;
                }
                if (data == "news") {
                    this.textVisible = true;
                    this.newsVisible = false;
                    this.imageVisible = true;
                    this.cardVisible = true;
                }
                if (data == "coupon") {
                    this.textVisible = true;
                    this.newsVisible = true;
                    this.imageVisible = true;
                    this.cardVisible = true;
                }
            },
            getList(){
                getKeywordContentList(this.formInline).then((res) => {
                    this.loading = false;
                    this.listData = res.data.value;
                })
            },
            getWeekDataList(){
                getWeekList().then((res) => {
                    this.execTypeValueList = res.data.value;
                })
            },
            keywordTypeChange(data){
                this.type = data
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            handleDel(row){
                if (confirm("确定删除关键字:" + row.keyword + "模板内容吗？")) {
                    deleteKeywordMessageContent({worldContentId: row.worldContentId}).then((res) => {
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList(this.currentPage, this.pageSize);
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }
            },
            handleAdd(){
                this.dialogFormVisible = true;
                getKeywordMessageContent({keyworldId:this.$route.query.keyworldId}).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.form = {
                            "type": res.data.value.type,
                            "keyworldId": '' || this.$route.query.keyworldId,
                            "title": res.data.value.title,
                            "content": res.data.value.content,
                            "mediaId": res.data.value.mediaId,
                            "imageUrl": res.data.value.imageUrl,
                            "status": res.data.value.status,
                            "url": res.data.value.url,
                            "execType": 1,
                            "keyword":res.data.value.keyword,
                            "type":res.data.value.type,
                            "execTypeValue": '',
                            "sort": 1
                        };
                        this.keywordTypeChange(this.form.type);
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }

                });
            },
            handleEdit(row){
                this.dialogFormVisible = true;
                this.form.worldContentId = row.worldContentId;
                this.form.keyworldId = row.keyworldId;
                this.form.type = row.type;
                this.form.title = row.title;
                this.form.content = row.content;
                this.form.mediaId = row.mediaId;
                this.form.imageUrl = row.imageUrl;
                this.form.status = row.status;
                this.form.execType = row.execType;
                this.form.sort = row.sort;
                this.form.execTypeValue = row.execTypeValue;
                this.form.url = row.url;
                this.keywordTypeChange(this.form.type);
            },
            save(data){
                console.log(data);
                if (data.type == "") {
                    this.$message({
                        message: "请选择关键字类型",
                        type: 'error'
                    });
                    return;
                }
                if (data.execTypeValue == "") {
                    this.$message({
                        message: "请选择执行时间",
                        type: 'error'
                    });
                    return;
                }
                if (data.type == "image" && data.imageUrl == "") {
                    this.$message({
                        message: "请选择图片",
                        type: 'error'
                    });
                    return;
                }
                if (data.type == "news" && data.mediaId == "") {
                    this.$message({
                        message: "请选择素材",
                        type: 'error'
                    });
                    return;
                }
                saveKeywordMessageContent(data).then((res) => {
                    if (res.data.success) {
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                        this.getList(this.currentPage, this.pageSize);
                        this.dialogFormVisible = false;
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            selectPicOne(obj){
                console.log(obj)
                this.$store.commit('SET_PIC_DIALOG',false)
                this.form.imageUrl = obj.allImagePath
                this.selectImageUrl = obj.allImagePath

            },
            selectUpload(){
                this.$store.commit('SET_PIC_DIALOG',true)
            },
            keywordType(row, column, cellValue) {
                for (var key in this.keywordTypeData) {
                    if (this.keywordTypeData[key].id == cellValue) {
                        return this.keywordTypeData[key].name;
                    }
                }
            },
            titleProccess(row, column, cellValue) {
                if (row.type == "news") {
                    return row.mediaTitle;
                } else {
                    return cellValue;
                }
            },
            returnHistory(){
                window.history.back()
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/views/wechat/wechatKeywordContent.vue